module.exports = __webpack_public_path__ + "0691f96ac591ee29908b5f05d8ee6025.jpg";